import { ModosOp} from "../../isp._comun/iu/_principal/constantesIuPrin";
import { TipoDeCliente, TipoDeDoc, Sexo } from "../../isp.žapi.clientes/constantesApiClientes";
import Contacto from "./Contacto";
import GeneradorDeSecuencia from './GeneradorDeSecuencia'

const primerNumeroSec = GeneradorDeSecuencia.primerNroSecuencial()
//Si no hay input para el Dialogo de Cliente a Facturar
const getEstadoInicial = () => {

    // let contactoDefinirNuevo = Contacto.crearContactoDefinirNuevo();

    return {
        domain: {
            screen:{
                idCliente: "-------",
                fechaReg: "--/--/--",
                estado: "-------",

                codigoCliente: "",
                tipoCliente: TipoDeCliente.DocId,
                tipoDoc: TipoDeDoc.DNI,
                nroDoc: "",
                nombres: "",
                apellidos: "",
                sexo: Sexo.SinDef,
                razonSocial: null,
                ruc: null,

                general: {
                    telcel1: "",
                    telcel2: "",
                    telfijo: "",
                    email: "",
                    sitioWeb: "",
                },

                /* cobranza: {
                    modoCobro: "cliente",
                    tipoComprobante: "bol",
                    cicloFact: "udiam",
                    controlTipoComprobante: true,
                    controlCicloFact: true,
                }, */

                // contactos: [],
                contactos: {
                    // valorListaNombres: contactoDefinirNuevo,
                    // listaNombres: [contactoDefinirNuevo],
                    valorListaNombres: { 
                        // sec: 1,
                        sec: primerNumeroSec,
                        // sec: GeneradorDeSecuencia.primerNroSecuencial(),
                        nombre: Contacto.labelDefinirNuevoContacto 
                    },
                    listaNombres: [{ 
                        // sec: 1,
                        sec: primerNumeroSec,
                        // sec: GeneradorDeSecuencia.primerNroSecuencial(),
                        nombre: Contacto.labelDefinirNuevoContacto 
                    }],
                    atributos: Contacto.crearContactoDefinirNuevo(),
                    /* atributos: {
                        nombre: Contacto.labelDefinirNuevoContacto,
                        rol: "",
                        telcel1: "",
                        telcel2: "",
                        telfijo: "",
                        email: "",
                    }, */
                    data: [],
                    contactoPorDefinir: Contacto.crearContactoDefinirNuevo(),
                    indexSeleccionado: 0,

                    // indexData: 0,
                    // contactosAct: [],
                    // contactosOrig: [],
                },
                personasContacto: {
                    valorListaNombres: { nombre: "Definir Nuevo" },
                    listaNombres: [{ nombre: "Definir Nuevo" }],
                    atributos: {
                        nombre: "Definir Nuevo",
                        rol: "",
                        telcel1: "",
                        telcel2: "",
                        telfijo: "",
                        email: "",
                    },
                    contactos: [],
                    // contactosAct: [],
                    // contactosOrig: [],
                    flagControNombreSelected: false,
                },
            },
            cargado: {}, //Data de una entidad cargada en el dialogo desde la Base de Datos
            update: {}, //Solo tiene data temporal del dominio va a modificar una entidad
            nroUpdates: 0,
        },

        /* domain: {
            idCliente: "-------",
            fechaReg: "--/--/--",
            estado: "-------",

            codigoCliente: "",
            tipoCliente: TipoDeCliente.DocId,
            tipoDoc: TipoDeDoc.DNI,
            nroDoc: "",
            nombres: "",
            apellidos: "",
            sexo: "",
            razonSocial: "",
            ruc: "",

            general: {
                telcel1: "",
                telcel2: "",
                telfijo: "",
                email: "",
                sitioWeb: "",
            },

            cobranza: {
                modoCobro: "cliente",
                tipoComprobante: "bol",
                cicloFact: "udiam",
                controlTipoComprobante: true,
                controlCicloFact: true,
            },

            contactos: [],
        }, */
        error: {
            nroDocBlanc: false,
            nroDocMF: false,
            nomBlanc: false,
            nomMF: false,
            apellBlanc: false,
            apellMF: false,
            sexoBlanc: false,
            rsocialBlanc: false,
            rsocialMF: false,
            rucBlanc: false,
            rucMF: false,
            telcel1Blanc: false,
            telcel1MF: false,
            telcel2MF: false,
            telfijoMF: false,
            emailMF: false,
            sitioWebMF: false,
        },
        flag: {
            modoOperacion: ModosOp.CREAR,
            procesandoComando: false,
            modal: false,
            cargandoEntidad: false,
            tipoClienteSelec: true,
            sensorCambioNombreContacto: false,
            sensorSeleccionDeValorDeLista: false,

            // iniciando: true
            // sensorDeAccionGuardar: false,
            // sensorDeAccionActualizar: false,
        },
        
        /* update: {
            codigoCliente: false,
            tipoCliente: false,
            tipoDoc: false,
            nroDoc: false,
            nombres: false,
            apellidos: false,
            sexo: false,
            razonSocial: false,
            ruc: false,

            general: {
                telcel1: false,
                telcel2: false,
                telfijo: false,
                email: false,
                sitioWeb: false,
            },

        }, */
    };
};


export default getEstadoInicial;
